import * as React from 'react'
import { useState } from 'react'
import Popup from 'reactjs-popup'

type SaveTemplatePopupProps = {
  open: boolean
  onClose: () => void
  onSave: (templateName: string) => void
  isLoading?: boolean
}

export default function SaveTemplatePopup({ open, onClose, onSave, isLoading }: SaveTemplatePopupProps) {
  const [templateName, setTemplateName] = useState('')

  const handleSave = () => {
    if (!templateName.trim()) return
    onSave(templateName.trim())
    setTemplateName('')
  }

  const handleClose = () => {
    setTemplateName('')
    onClose()
  }

  return (
    <Popup 
      open={open} 
      onClose={handleClose} 
      position="center center" 
      contentStyle={{ width: 'auto', maxWidth: '100%', zIndex: 9999 }}
      overlayStyle={{ zIndex: 9998 }}
      modal 
      nested
    >
      <div className="modal-popup">
        <a className="close" onClick={handleClose}>
          &times;
        </a>
        <div className="popup-header">
          <h6 className="modal-title">Gem som skabelon</h6>
        </div>
        <div className="popup-content">
          <input
            type="text"
            className="form-control"
            placeholder="Template name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSave()}
          />
        </div>
        <div className="popup-actions">
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleSave}
            disabled={!templateName.trim() || isLoading}
          >
            Save
          </button>
        </div>
      </div>
    </Popup>
  )
}